<template>
  <steps v-show="isChange && signOnline" />
  <router-view v-slot="{ Component }" name="sign-contract">
    <keep-alive :include="keepAliveRoutes" :exclude="excludeRoutes">
      <component :is="Component" :key="undefined" />
    </keep-alive>
  </router-view>
</template>
<script lang="ts">
export default {
  name: 'SignContractLayout',
};
</script>
<script setup lang="ts">
import Steps from './components/Steps.vue';
import { keepAliveRoutes, excludeRoutes, addRouteToExclude, recoverKeepAlive } from '@/router/routes';
import { onBeforeRouteLeave } from 'vue-router';
import { RecordsActionTypeEnum, SignModeEnum } from '@/enums/CommonEnum';
import { useConfigStore } from '@/store/modules/config';

const configStore = useConfigStore();
const signOnline = configStore.dict?.dynamicConfig?.feSysConfig?.signMode !== SignModeEnum.sync;
const { currentRoute } = useRouter();
const ins = getCurrentInstance();
const type: number = Number(currentRoute.value?.query?.type);
const isChange = type !== RecordsActionTypeEnum.modifySign;
onBeforeRouteLeave((to) => {
  if (
    ![
      'agreement-page',
      'select-sign-org',
      'add-record-step3',
      'contract-index',
      'contract-service',
      'contract-doctorteam',
      'contract-package',
    ].includes(String(to.name))
  ) {
    addRouteToExclude(String(ins?.type.name));
  } else {
    recoverKeepAlive(String(ins?.type.name));
  }
});
</script>
